import { axios, withPartialContent } from 'shared/services/axios'

export const fetchCampaign = withPartialContent(({ boardId }) => {
  return axios.get(`/live_board/v2/boards/${boardId}/campaign`)
})
